import React, { Component, createRef, RefObject } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import ContentLayout from '../../components/ContentLayout'
import ContentMain from '../../components/ContentMain'
import Template from '../../components/LabelBuilder/Template'
import TemplateProperties from '../../components/LabelBuilder/TemplateProperties'
import Actions from '../../components/LabelBuilder/Actions'
import Aside from '../../components/LabelBuilder/Aside'
import { Transformer } from 'konva/lib/shapes/Transformer'

interface Props extends RouteComponentProps {}

class LabelBuilder extends Component<Props> {
  transformerRef: RefObject<Transformer> = createRef()

  render () {
    return (
      <ContentLayout
        noGap={true}
        className="h-[calc(100vh-40px)]">
        <ContentMain
          layout="twoThird"
          className="border-r border-blue-100 flex flex-col">
          <div className='flex-none'>
            <TemplateProperties />
          </div>
          <div className='flex-auto overflow-auto bg-gray-200'>
            <Template transformerRef={this.transformerRef} />
          </div>
          <div className='flex-none'>
            <Actions transformerRef={this.transformerRef} />
          </div>
        </ContentMain>
        <ContentMain
          layout="oneThird"
          className='overflow-y-scroll'>
          <Aside transformerRef={this.transformerRef} />
        </ContentMain>
      </ContentLayout>
    )
  }
}

export default withRouter(LabelBuilder)
